import { ControlPresentationProvider } from "@freightsimple/ui-core/Controls/ControlPresentationProvider";
import { Dialog } from "@freightsimple/ui-core/Dialog/Dialog";
import type { UUID } from "@/Shared/types";
import type { ReactNode } from "react";
import { useRef, useState } from "react";
import { UploadCustomsDocsDialogBody } from "@/Shared/Shipment/Dialogs/Internal/UploadCustomsDocsDialogBody";

// Hosts the legacy customs-docs upload form (it renders its own upload
// button) in a ui-core Dialog, bridged to the awaited uploaded/not result.
export function useUploadCustomsDocsDialog(trackingId: UUID): {
  show: () => Promise<boolean>;
  dialogs: ReactNode;
} {
  const [open, setOpen] = useState(false);
  const [openCount, setOpenCount] = useState(0);
  const resolverRef = useRef<((uploaded: boolean) => void) | undefined>(
    undefined,
  );

  function show(): Promise<boolean> {
    return new Promise((resolve) => {
      resolverRef.current = resolve;
      setOpenCount((count) => count + 1);
      setOpen(true);
    });
  }

  function settle(uploaded: boolean) {
    resolverRef.current?.(uploaded);
    resolverRef.current = undefined;
  }

  const dialogs = (
    <Dialog
      key={`shipment-upload-customs-docs-${openCount}`}
      open={open}
      onOpenChange={function (nowOpen) {
        setOpen(nowOpen);
        if (!nowOpen) {
          settle(false);
        }
      }}
    >
      <ControlPresentationProvider presentation="underlined">
        <UploadCustomsDocsDialogBody
          trackingId={trackingId}
          onFinished={function () {
            settle(true);
            setOpen(false);
          }}
          onCancel={function () {
            settle(false);
            setOpen(false);
          }}
        />
      </ControlPresentationProvider>
    </Dialog>
  );

  return { show, dialogs };
}
